import { render, staticRenderFns } from "./PersonalizedGameEditor.vue?vue&type=template&id=22ecbf71&scoped=true&"
import script from "./PersonalizedGameEditor.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditor.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizedGameEditor.vue?vue&type=style&index=0&id=22ecbf71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ecbf71",
  null
  
)

export default component.exports